export default __webpack_public_path__ + "static/media/lap_image6.5145fff7.jfif";